import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'

const useStyles = makeStyles(theme => ({
  root: {
    fontSize: 16,
    color: '#4A4A4A',
    lineHeight: 1.5,
    marginBottom: 20,
  },
  question: {
    fontWeight: 'bold',
  },
  answer: {
    
  },
}))

const EssayField = (props) => {
  const { question, answer, className, ...others } = props
  const classes = useStyles()

  return (
    <div className={clsx(classes.root, className)} {...others}>
      <div className={classes.question}>{question}</div>
      <div className={classes.answer}>{answer}</div>
    </div>
  )
}

export default EssayField